// extracted by mini-css-extract-plugin
export default {"transition_container":"styles_transition_container__efUSY","animation":"styles_animation__Xmjxt","waving":"styles_waving__zc7Hj","visible":"styles_visible__PN6Cq"};